import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import localization from "../../../../assets/localization/localization";
import TextAreaInput from "../../../../components/sales/Input/textAreaInput/textAreaInput";
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import {Button} from "react-bootstrap";
import Layout from "../../../../components/sales/layout/layout";
import {toast} from "react-toastify";
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";

// PRD §3.2 — the 10 ticket type options.
const TICKET_TYPES = [
    { id: 'Service Executive Ticket Support',    name: 'Service Executive Ticket Support' },
    { id: 'Project Executive Ticket Support',    name: 'Project Executive Ticket Support' },
    { id: 'Channel Partner Engineer Support',    name: 'Channel Partner Engineer Support' },
    { id: 'Process Flow Discussion',             name: 'Process Flow Discussion' },
    { id: 'New Requirement Discussion',          name: 'New Requirement Discussion' },
    { id: 'Review & Training',                   name: 'Review & Training' },
    { id: 'KT / BRD / Team Discussion',          name: 'KT / BRD / Team Discussion' },
    { id: 'New Flow Testing & Validation',       name: 'New Flow Testing & Validation' },
    { id: 'Improvement Task',                    name: 'Improvement Task' },
    { id: 'Other Activities',                    name: 'Other Activities' },
];

const ComplaintForCentralTech = ({
    documentUploadUrlPublic,
    siteData,
    documentUrlDataPublic = [],
    siteDetails = [],
    centralTechComplainRaise
}) => {

    const history = useHistory();
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedSiteId, setSelectedSiteId] = useState(null);
    const [selectedTicketType, setSelectedTicketType] = useState(null);
    const [inputList, setInputList] = useState([{
        site_no: '',
        desc: '',
        document: '',
        ticket_type: '',
    }]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await siteData();
            setIsLoading(false)
        })()
    }, []);

    const handleInput = (key, val) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList(list);
    }

    // PRD §3.1 — show Infra ID alongside site name in the dropdown.
    const formattedSiteDetails = siteDetails.map(site => ({
        ...site,
        name: (() => {
            const siteNo = site.site_no || site.id || '';
            const infra = site.infra_id || site.infra_project_id || '';
            const displayName = site.client_name || site.name || '';
            // Legacy /procurement/get-sites may return preformatted name; still prefer showing infra_id when available.
            if (!site.site_no && site.name) {
                if (!infra) return site.name;
                if (site.name.includes(`(${infra})`)) return site.name;
                return `${site.name} [Infra: ${infra}]`;
            }
            if (infra) return `${siteNo} (${infra}) - ${displayName}`;
            return `${siteNo}${displayName ? ' - ' + displayName : ''}`;
        })(),
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!inputList[0].site_no) {
            toast.error('Site is required');
            return;
        }
        if (!inputList[0].desc) {
            toast.error('Complaint description is required');
            return;
        }
        if (!inputList[0].ticket_type) {
            toast.error('Ticket type is required');
            return;
        }
        setIsLoading(true);
        const result = await centralTechComplainRaise(inputList[0]);
        setIsLoading(false);
        if (result?.ok) {
            toast.success(result.message || 'Complaint raised successfully');
            history.push(`${baseUrl}/central-tech-complain-list`);
        }
    }

    return (
        <Layout
            title={'Raise CTE Ticket'}
            isLoading={isLoading}
            isGoback={true}
        >
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body">
                        <div className='row'>
                            {/* Site dropdown — PRD §3.1 shows Infra ID */}
                            <div className="col-md-6 col-sm-12">
                                <DropDownInput
                                    label={localization.SiteNo}
                                    data={formattedSiteDetails}
                                    getIdValue={(val) => {
                                        if (!val?.id) return;
                                        setSelectedSiteId(val.id);
                                        const site = formattedSiteDetails.find(
                                            (s) => String(s.id) === String(val.id)
                                        );
                                        handleInput('site_no', site?.site_no || String(val.id));
                                    }}
                                    getValueById={selectedSiteId}
                                    isStarRequired={true}
                                />
                            </div>

                            {/* PRD §3.2 — Ticket Type dropdown */}
                            <div className="col-md-6 col-sm-12">
                                <DropDownInput
                                    label="Ticket Type"
                                    data={TICKET_TYPES}
                                    getIdValue={(val) => {
                                        if (!val?.id) return;
                                        setSelectedTicketType(val.id);
                                        handleInput('ticket_type', val.id);
                                    }}
                                    getValueById={selectedTicketType}
                                    isStarRequired={true}
                                />
                            </div>

                            <div className="col-md-6 col-sm-12">
                                <TextAreaInput
                                    type="text"
                                    rows={4}
                                    label={'Complaint Description'}
                                    required
                                    isStarRequired
                                    handleChange={(e) => handleInput('desc', e.target.value)}
                                    inputValue={inputList[0]['desc']}
                                    value={inputList[0]['desc']}
                                />
                            </div>

                            <div className="col-md-6 col-sm-12">
                                <FileUpload
                                    id={"cteComplaintAttachment"}
                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => handleInput('document', val)}
                                    multiple={true}
                                >
                                    <span className="btn btn-transparent">Attachment</span>
                                </FileUpload>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mb-2">
                    <center>
                        <Button onClick={(e) => { handleSubmit(e) }}>
                            {localization.submitDtl}
                        </Button>
                    </center>
                </div>
            </div>
        </Layout>
    )
}

export default ComplaintForCentralTech;
